<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns :fields="fields" class="customize" />
          </div>
          <div style="overflow:auto">
            <b-table
              id="user-clocking-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{afterResize: columnsWidthChanged}"
            >
              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>

              <template v-slot:head(online)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(username)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(etenant_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(eshop_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(eterminal_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(session)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(ip)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(connected_at)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(disconnected_at)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(duration)="data">{{ $t(data.label) }}</template>

              <template v-slot:cell(online)="data">
                <span v-if="data.item.disconnected_at == 0" class="text-success">{{$t("ONLINE")}}</span>
                <span v-else class="text-danger">{{$t("OFFLINE")}}</span>
              </template>

              <template v-slot:cell(duration)="data">
                <span>{{duration(data.item.connected_at, data.item.disconnected_at)}}</span>
              </template>

              <template v-slot:cell(username)="data">
                <router-link
                  :to="`/users/${data.item.euser_id}`"
                  v-if="data.item.euser_id"
                >{{data.item.username ? data.item.username : data.item.euser_id}}</router-link>
              </template>

              <template v-slot:cell(etenant_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/tenants/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(eshop_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(eterminal_id)="data">
                <span v-if="data.value.to">
                  <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                </span>
                <span v-else>{{ data.value.name }}</span>
              </template>

              <template v-slot:cell(connected_at)="data">
                <span>{{ mom_unix(data.value).format(tableDateLong) }}</span>
              </template>
              <template v-slot:cell(disconnected_at)="data">
                <span v-if="data.value != 0">{{ mom_unix(data.value).format(tableDateLong) }}</span>
                <span v-else>{{$t("IN PROGRESS")}}</span>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'user-clocking-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";
import timeFormat from "@/shared/timeFormat";

export default {
  name: "user-clocking",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "user-clocking",
      filterOptions: [
        {
          field: "company_id",
          multiple: true,
          placeholder: "Company",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "companies",
          hide_select: true,
          filterOptions: ["tenant_id"],
          options: [],
          selected: [],
          postIgnore: false
        },
        {
          field: "tenant_id",
          multiple: true,
          placeholder: "Tenant",
          trackBy: "eid",
          label: "brand_name",
          translate: false,
          store: "tenants",
          hide_select: true,
          filterOptions: ["shopgroup_id", "shop_id"],
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const orig = data.list[1].originalOptions;
            if (
              selected.length == 0 &&
              data.list[1].options.length != orig.length
            ) {
              data.list[1].options = orig;
            } else if (selected.length != 0) {
              data.list[1].options = orig.filter(item => {
                if (selected.indexOf(item.ecompany_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },

        {
          field: "shopgroup_id",
          multiple: true,
          placeholder: "Shop Group",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shopGroups",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          filterOptions: ["shop_id"],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            const selected = fieldValue.map(elem => elem.eid);
            const index = 2;
            const orig = data.list[index].originalOptions;
            if (selected.length == 0) {
              data.list[index].options = orig;
            } else {
              data.list[index].options = orig.filter(item => {
                if (selected.indexOf(item.etenant_id) > -1) {
                  return true;
                }
                return false;
              });
            }
          }
        },
        {
          field: "shop_id",
          multiple: false,
          placeholder: "Shop",
          trackBy: "eid",
          label: "name",
          translate: false,
          store: "shops",
          hide_select: true,
          options: [],
          originalOptions: [],
          selected: [],
          postIgnore: false,
          filterOptionsBy: (data, field, fieldValue) => {
            let selectedTenants = [];
            let selectedShopGroups = [];

            if (field == "tenant_id") {
              selectedTenants = fieldValue.map(elem => elem.eid);
            } else {
              selectedTenants = data.list[0].selected.map(elem => elem.eid);
            }
            if (field == "shopgroup_id") {
              selectedShopGroups = fieldValue.map(elem => elem.eshop_ids);
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            } else {
              selectedShopGroups = data.list[2].selected.map(
                elem => elem.eshop_ids
              );
              if (selectedShopGroups.length) {
                selectedShopGroups = [].concat.apply([], selectedShopGroups);
              }
            }
            const index = 3;
            const orig = data.list[index].originalOptions;

            if (!selectedTenants.length && !selectedShopGroups.length) {
              data.list[index].options = orig;
            } else {
              let tmp = [];

              if (selectedTenants.length) {
                tmp = orig.filter(item => {
                  if (selectedTenants.indexOf(item.etenant_id) > -1) {
                    return true;
                  }
                  return false;
                });
              }

              if (selectedShopGroups.length) {
                if (!selectedTenants.length && !selectedTenants.length) {
                  tmp = orig;
                }
                tmp = tmp.filter(item => {
                  if (selectedShopGroups.indexOf(item.eid) > -1) {
                    return true;
                  }
                  return false;
                });
              }
              data.list[index].options = tmp;
            }
          }
        },
        {
          field: "report_time",
          type: "date",
          opens: "right",
          showDropdowns: true,
          selected: {
            startDate: moment(),
            endDate: moment()
          },
          default: {
            startDate: moment(),
            endDate: moment()
          },
          singleDatePicker: true,
          timePicker: false,
          locale: {
            format: timeFormat.datePickerShort, //format of the dates displayed
            firstDay: 1, //ISO first day of week - see moment documenations for details
            showWeekNumbers: true //show week numbers on each row of the calendar
          },
          ranges: false
        }
      ],
      isBusy: false,
      sortBy: "shop_id",
      sortDesc: true,
      // ua.user_id, u.cnp, u.name, u.surname, ua.shop_id, s.name, ua.day, ua.td
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",
      selectedeid: ""
    };
  },
  computed: {
    fields() {
      const columns = [
        {
          key: "user_cnp",
          label: "CNP",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "user_name",
          label: "Name",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "user_surname",
          label: "Surname",
          sortable: false,
          class: "",
          ignore: true
        },
        {
          key: "shop_name",
          label: "Shop Name",
          sortable: false,
          class: "",
          ignore: true
        }
      ];

      for (let i = 1; i <= 31; i++) {
        columns.push({
          key: `day_${i}`,
          label: `${i}`,
          sortable: false,
          class: "",
          ignore: true
        });
      }

      columns.push({
        key: `worked_hours`,
        label: `Worked Hours`,
        sortable: false,
        class: "",
        ignore: true
      });
      columns.push({
        key: `worked_days`,
        label: `Worked Days`,
        sortable: false,
        class: "",
        ignore: true
      });
      return columns;
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "user-clocking-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        if (sortBy == "eterminal_id") sortBy = "terminal_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length && !item.postIgnore) {
          exactFields.push(item.field);
          if (item.trackBy) {
            const tmp = [];
            item.selected.forEach(el => {
              tmp.push(el[item.trackBy]);
            });
            exactValues.push(tmp);
          } else {
            exactValues.push(item.selected);
          }
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = this.processDate(
              item.selected.startDate
            );
            paginationData.dateEnd = this.processDate(item.selected.endDate);
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const shopByID = this.$store.getters["cache/shopByID"];
      const terminalByID = this.$store.getters["cache/terminalByID"];

      Promise.all([
        this.$store.dispatch("cache/fetch", "tenants").catch(e => e),
        this.$store.dispatch("cache/fetch", "shops").catch(e => e),
        this.$store.dispatch("cache/fetch", "terminals").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("userClocking/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;
            resp.data.rows.forEach((item, index) => {
              if (item.days) {
                let total_hours = 0;
                let total_days = 0;

                for (let i = 1; i <= 31; i++) {
                  if (typeof item.days[i - 1] !== "undefined") {
                    if (item.days[i - 1] !== 0) {
                      total_days += 1;
                      total_hours += item.days[i - 1];
                    }
                    item[`day_${i}`] = this.minutesToHM(item.days[i - 1]);
                  } else {
                    item[`day_${i}`] = "0";
                  }
                }

                item.worked_hours = this.minutesToHM(total_hours);
                item.worked_days = total_days;
              }
            });
            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(err.message),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });
      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    rowClicked(item, index, event) {},
    mom_unix(val) {
      return moment.unix(val / 1e9);
    },
    processDate(dt) {
      let fdt = null;
      if (typeof dt.format !== "undefined") {
        fdt = dt.format().split("T")[0];
      } else {
        fdt = this.toDate(dt);
      }
      return `${fdt}T00:00:00.000Z`;
    },
    toDate(st) {
      let date_ob;
      if (st) {
        date_ob = new Date(st);
      } else {
        date_ob = new Date();
      }

      let days = ("0" + date_ob.getDate()).slice(-2);
      let month = ("0" + (date_ob.getMonth() + 1)).slice(-2);
      let year = date_ob.getFullYear();

      return `${year}-${month}-${days}`;
    },
    minutesToHM(value) {
      const hours = Math.floor(value / 60);
      const minutes = value % 60;
      let ret = "";
      if (hours > 0) {
        ret += `${hours}h `;
      }
      if (minutes > 0) {
        ret += `${minutes}m`;
      }
      return ret === "" ? "0" : ret;
    },
    duration(sd, ed) {
      sd = this.mom_unix(sd);
      if (ed === 0) {
        ed = moment();
      } else {
        ed = this.mom_unix(ed);
      }
      const dr = moment.duration(ed.diff(sd));
      let ret = "";
      if (dr.days()) {
        ret = `${dr.days()}d `;
      }
      if (dr.hours()) {
        ret = ret + `${dr.hours()}h `;
      }
      if (dr.minutes()) {
        ret = ret + `${dr.minutes()} min `;
      }
      if (dr.seconds()) {
        ret = ret + `${dr.seconds()} sec `;
      }
      return ret;
    },
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
</style>


